import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { confirmPasswordReset } from "../../actions/auth";
import { createMessage } from "../../actions/messages";
import Modal from "../common/Modal/Modal";
import { useSubmitGuard } from "../common/Helpers";

export function ResetPassword(props) {

    const [passwords, setPasswords] = useState({ password: "", passwordconfirm: "" });
    const [success, setSuccess] = useState(false);
    const { isSubmitting, guardedSubmit } = useSubmitGuard();

    const onChange = (e) => setPasswords({ ...passwords, [e.target.name]: e.target.value });

    const onSubmit = guardedSubmit((e) => {
        e.preventDefault();

        if (passwords.password !== passwords.passwordconfirm) {
            props.createMessage({ error: "Passwords do not match" });
            return undefined;
        }

        return props
            .confirmPasswordReset(props.match.params.uidb64, props.match.params.token, passwords.password)
            .then((didSucceed) => didSucceed && setSuccess(true));
    });

    if (success) {
        return <Redirect to="/login" />;
    }

    return (
        <Modal slogan={true} className="reset-password">
            <form className="form" onSubmit={(e) => onSubmit(e)}>
                <div className="inputs-wrapper gap-below-s">
                    <div className="input-basic">
                        <input
                            type="password"
                            name="password"
                            onChange={(e) => onChange(e)}
                            value={passwords.password}
                            id="password"
                            required
                        />
                        <label htmlFor="password">New Password </label>
                    </div>
                    <div className="input-basic">
                        <input
                            type="password"
                            name="passwordconfirm"
                            onChange={(e) => onChange(e)}
                            value={passwords.passwordconfirm}
                            id="passwordconfirm"
                            required
                        />
                        <label htmlFor="passwordconfirm">Confirm New Password </label>
                    </div>
                </div>
                <div className="flex-row center">
                    <button style={{width: "100%"}} type="submit" id="reset-password" className="btn pri gap-below-s gap-above-s" disabled={isSubmitting}>
                        {isSubmitting ? "RESETTING..." : "RESET PASSWORD"}
                    </button>
                </div>
            </form>
            <Link style={{width: "100%"}} id="request-new-link" className="btn sec gap-below-m" to="/forgot-password">REQUEST A NEW LINK</Link>
        </Modal>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { confirmPasswordReset, createMessage })(ResetPassword);
